import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-532cc6a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "certificates pt-3" }
const _hoisted_2 = { class: "certificates_content shadow-sm" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-header p-2" }, "Giấy chứng nhận", -1))
const _hoisted_4 = {
  key: 0,
  class: "content-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CertificatesItem = _resolveComponent("CertificatesItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.certificates && _ctx.certificates.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificates, (item, index) => {
              return (_openBlock(), _createBlock(_component_CertificatesItem, {
                onClick: ($event: any) => (_ctx.handleDetail(index)),
                certificat: item,
                key: index
              }, null, 8, ["onClick", "certificat"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}